export default class ValidationResponse {
  constructor(obj) {
    if (!obj) obj = {};
    this.valid = obj.valid ? obj.valid : false;
    this.actionId = obj.actionId ? obj.actionId : 0;
    this.expired = obj.expired ? obj.expired : false;
    this.linkId = obj.linkId ? obj.linkId : "";
    this.redirectURL = obj.redirectURL ? obj.redirectURL : "";
    this.decryptKey = obj.decryptKey ? obj.decryptKey : "";
    this.partialCode = obj.partialCode ? obj.partialCode : null;
  }
}
